module.exports = __webpack_public_path__ + "static/media/ALT.9769f93e.png";